import React, { useState, useEffect, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import {
    Row,
    Col,
    Input,
    Card,
    CardBody,
} from 'reactstrap'
import moment from 'moment'
import 'moment/min/locales'
import { isEmpty, head } from 'lodash'
import CurrencyFormat from 'react-currency-format'
import ApiService from '../../../data/services/ApiService'
import {
    getClassOrderStatus,
    getUrlOfDefaultProductImage
} from '../../../helpers/utils'
import { GeneralContext } from '../../../context/'

moment.locale('es')

const DetailDatatable = (props) => {
    const generalContext = useContext(GeneralContext)
    const { setLoading } = generalContext

    const [order, setOrder] = useState({})
    const [list, setList] = useState([])
    const [filteredData, setFilteredData] = useState([])
    const [firstVariantLabel, setFirstVariantLabel] = useState('')
    const [secondVariantLabel, setSecondVariantLabel] = useState('')
    const [thirdVariantLabel, setThirdVariantLabel] = useState('')

    const itemId = props.match.params.id

    useEffect(() => {
        (async function fetch() {
            await fetchData()
        })()

        async function fetchData() {
            setLoading(true)
            const response = await ApiService.getDetailOfOrderByUser(itemId)
            setOrder(response.data.order)
            if (!isEmpty(head(response.data.data).productVariant)) {
                setFirstVariantLabel(head(response.data.data).productVariant.firstOption.label)
                setSecondVariantLabel(head(response.data.data).productVariant.secondOption.label)
                setThirdVariantLabel(head(response.data.data).productVariant.thirdOption.label)
            }
            setList(response.data.data)
            setFilteredData(response.data.data)
            setLoading(false)
        }
    }, [itemId]) // eslint-disable-line

    const _filterData = async (e) => {
        const keystroke = e.target.value.toLowerCase()
        const filteredData = list.filter((item) => {
            const name = item.name || ''
            const description = item.description || ''
            return name.toLowerCase().includes(keystroke) ||
                description.toLowerCase().includes(keystroke)
        })

        setFilteredData(filteredData)
    }

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    {
                        !isEmpty(order) ? (
                            <Row className="font-bold">
                                <Col sm="2">
                                    {`Pedido ${order.folio}`}
                                </Col>
                                <Col sm="3">
                                    Cliente: {order.customerName}
                                </Col>
                                <Col sm="2">
                                    Fecha: {moment(order.createdAt, 'YYYY-MM-DD').format('DD MMM YYYY')}
                                </Col>
                                <Col sm="2">
                                    Total: {
                                        <CurrencyFormat
                                            value={order.total}
                                            displayType="text"
                                            thousandSeparator
                                            prefix="$"
                                        />
                                    }
                                </Col>
                                <Col sm="3">
                                    <div className={getClassOrderStatus(order.status.codeName)}>
                                        {order.status.name}
                                    </div>
                                </Col>
                            </Row>
                        ) : null
                    }
                </CardBody>
                <CardBody>
                    <Row className="mb-2">
                        <Col sm="4">
                            <div className="search-box mr-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                    <Input type="text" className="form-control"
                                        placeholder="Buscar ..."
                                        onKeyUp={(e) => _filterData(e)}
                                    />
                                    <i className="bx bx-search-alt search-icon"></i>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div className="table-responsive">
                        <table className="table table-centered table-nowrap mb-0">
                            <thead className="thead-light">
                                <tr>
                                    <th>Producto</th>
                                    <th>Código</th>
                                    <th>Nombre</th>
                                    <th>Precio</th>
                                    { !isEmpty(firstVariantLabel) && (
                                        <th>{firstVariantLabel}</th>
                                    )}
                                    { !isEmpty(secondVariantLabel) && (
                                        <th>{secondVariantLabel}</th>
                                    )}
                                    { !isEmpty(thirdVariantLabel) && (
                                        <th>{thirdVariantLabel}</th>
                                    )}
                                    <th>Cantidad</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map(
                                    (item, key) => (
                                        <tr key={"_tr_" + key}>
                                            <td>
                                                <div className="position-relative product-image-default">
                                                    <img src={getUrlOfDefaultProductImage()} alt="" className="img-fluid mx-auto d-block" />
                                                </div>
                                            </td>
                                            <td>{item.product.productCode}</td>
                                            <td>{item.product.name}</td>
                                            <td>
                                                <CurrencyFormat
                                                    value={item.subtotal}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </td>
                                            {
                                                !isEmpty(firstVariantLabel) && (
                                                    <td>
                                                        {item.productVariant.firstOption.value}
                                                    </td>
                                                )
                                            }
                                            {
                                                !isEmpty(secondVariantLabel) && (
                                                    <td>
                                                        {item.productVariant.secondOption.value}
                                                    </td>
                                                )
                                            }
                                            {
                                                !isEmpty(thirdVariantLabel) && (
                                                    <td>
                                                        {item.productVariant.thirdOption.value}
                                                    </td>
                                                )
                                            }
                                            <td>{item.quantity}</td>
                                            <td>
                                                <CurrencyFormat
                                                    value={item.subtotal - item.discount}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </td>
                                        </tr>
                                    )
                                )}
                            </tbody>
                        </table>
                    </div>
                </CardBody>
            </Card>
        </React.Fragment>
    )
}

export default withRouter(DetailDatatable)
